import { useEffect, useState } from 'react';
import _ from 'lodash';
import React from 'react';

import HrSearchComponents from '../../../../HRAdmin/components/HrSearchComponent';
import { useDebounce } from '../../../../../hooks';
import ClockInButton from '../../../../ClockInButton';
import { useTranslation } from 'react-i18next';
import MUIDataTable from 'mui-datatables';
import orgStructure from '../../../../../api/orgStructure';
import organisation from '../../../../../api/organisation';
import { useApp } from '../../../../../context';
import { DefaultAvatar } from '../../../../../common/constants';
import FetchImage from '../../../../Common/FetchImage';
import { pagination_list } from '../../../../../common/enum';
import {
  CustomToast,
  arabicLocalization,
} from '../../../../../common/Methodcommon';
import NewReportingStructure from '../../../../OrganisationStructure/components/NewReprortingStructure';
import Warning from '../../../../Warning';
import EditManager from '../../../../OrganisationStructure/components/EditManager';

// Small reusable Tailwind-only modal (replaces MUI Dialog)
const ConfirmModal = ({ open, onClose, children }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      onClick={onClose}
    >
      <div
        className="w-full max-w-[420px] rounded-xl bg-white p-6 shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

const FaceReportStructure = () => {
  const { t, i18n } = useTranslation();
  const [debouncedTerm, setQuery] = useDebounce();
  const [debounceTerm, setDebounceTerm] = useState('');
  const [debounceTermRole, setDebounceTermRole] = useDebounce('');
  const [searchTerm, setSearchTerm] = useState(debounceTerm);
  const { companyId, userId } = useApp();

  const [totalCount, setTotalCount] = useState(0);
  const [logTotalCount, setLogTotalCount] = useState(0);
  const [addFaceReport, setAddFaceReport] = useState(false);
  const [faceReportStructureData, setFaceReportStructureData] = useState([]);
  const [statusTitle, setStatusTitle] = useState('Select');
  const [statusFilter, setStatusFilter] = useState(0);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const { rowsPerPage, changeRowsPerPage } = useApp();
  const [page, setPage] = useState(0);
  const [currentfaceReportingToEdit, setCurrentFaceReportingToEdit] = useState(
    {},
  );
  const [openEditFaceReportee, setOpenEditFaceReportee] = useState(false);

  // ---- Add Report Structure (NewReportingStructure) state ----
  const [rootCompanyId, setRootCompanyId] = useState(undefined);
  const [companySubsidaries, setCompanySubsidaries] = useState([]);
  const [companyEmployees, setCompanyEmployees] = useState([]);
  const [selectedCompanyEmployees, setSelectedCompanyEmployees] = useState([]);
  const [isEmployeeLoaded, setIsEmployeeLoaded] = useState(true);
  const [roleListForRoleAssignment, setRoleList] = useState([]);
  const [managers, setManagers] = useState([]);
  const [assert, setAssert] = useState(false);
  const [updateOnConfirm, setUpdateOnConfirm] = useState(null);

  const customRender = {
    sort: true,
    filter: true,
    customBodyRender: (value) => <td className="text">{value}</td>,
  };

  const optionsFaceReportStructure = {
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    elevation: 0,
    filter: false,
    selectableRowsHeader: false,
    selectableRows: false,
    textLabels: i18n.language === 'ar' ? arabicLocalization : '',
  };

  const faceReportStructureColumns = [
    {
      name: 'reporter',
      label: t('Reporting To'),
      options: customRender,
    },
    {
      name: 'roles',
      label: t('Roles'),
      options: customRender,
    },
    {
      name: 'businessUnit',
      label: t('Business Unit'),
      options: customRender,
    },
    {
      name: 'employees',
      label: t('Reportees(#)'),
    },
    {
      name: 'action',
      label: t('Action'),
      options: customRender,
    },
  ];

  useEffect(() => {
    refreshFaceReportingStructure();
  }, [page, rowsPerPage, searchTerm]);

  // ---- Bootstrap company hierarchy for NewReportingStructure ----
  useEffect(() => {
    if (!rootCompanyId) {
      const cid = localStorage.getItem('__current_company_id');
      orgStructure
        .getCompanySubsidiriesList(cid)
        .then((res) => {
          setRootCompanyId(res?.companyId);
          if (res) {
            traverse(res);
          }
        })
        .catch((err) => console.log(err));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const traverse = function (current) {
    if (current?.isActive) {
      var obj = { companyId: current.companyId, name: current.name };
      setCompanySubsidaries((current) => [...current, obj]);
    }
    if (typeof current.children != 'undefined') {
      _.map(current.children, function (element) {
        traverse(element);
      });
    }
  };

  const refreshFaceReportingStructure = () => {
    orgStructure
      .facereportingStructure(companyId, page + 1, rowsPerPage, searchTerm)
      .then((res) => {
        const cp = localStorage.getItem('__active_company__');
        const admin = localStorage.getItem('__active_user_is_admin__');

        let company_id = 0;
        let is_admin = 0;
        if (cp) {
          company_id = Number(cp);
        }
        if (admin === 'true') {
          is_admin = 1;
        }
        setTotalCount(res?.total_count);
        const list = res?.data;
        if (!is_admin && company_id) {
          const list1 = _.filter(res?.data, function (o) {
            return o.CompanyID === company_id;
          });
          const list = list1;
        }

        let m = _.map(list, function (o) {
          const manager = o.user;
          let profile_pic = DefaultAvatar;
          if (o.profile_pic) profile_pic = `${o.profile_pic}`;

          const reporteesCount = o.reportees
            ? o.idx.split(',').map((r) => r.trim()).length
            : 0;

          return {
            id: o.user_id,
            reporter: (
              <div className="flex flex-row items-center gap-2">
                <div className="flex-shrink-0">
                  <FetchImage
                    type={'avatar'}
                    src={profile_pic}
                    className="w-[38px] h-[38px]"
                    variant="circle"
                  />
                </div>
                <div className="flex flex-col">
                  <p className="text-[0.9em] font-bold">{o.ManagerName}</p>
                  <p className="text-[0.9em] text-gray-500">
                    {o.ManagerStaffId}
                  </p>
                </div>
              </div>
            ),
            roles: o.ManagerRoleName,
            businessUnit: o.CompanyName,
            employees: (
              <span className="inline-flex items-center gap-1 rounded-full border border-gray-300 px-2.5 py-0.5 text-xs">
                <i className="las la-user-friends"></i>
                {reporteesCount}
              </span>
            ),
            action: (
              <div className="flex flex-row items-center justify-center">
                <button
                  className="flex h-[29px] w-[29px] items-center justify-center rounded-md border border-gray-200 bg-[#fcfcfc] text-[#7C0E6F] hover:bg-gray-100"
                  onClick={() => handleEditFaceReporting(o, profile_pic)}
                >
                  <i className="las la-eye"></i>
                </button>
              </div>
            ),
          };
        });

        setFaceReportStructureData(m);
      })
      .catch((err) => console.log(err));
  };

  const handleEditFaceReporting = (record, profile) => {
    let m = record;
    m.profile_pic = profile;
    setCurrentFaceReportingToEdit(m);
    setOpenEditFaceReportee(true);
  };
  const handleCloseFaceEditReporteeModal = () => {
    setOpenEditFaceReportee(false);
  };

  // ---- NewReportingStructure handlers (mirrors OrganisationStructure) ----
  const handleSelectCompany = (id) => {
    getEmployeesOfCompany(id);
  };

  const getEmployeesOfCompany = (id) => {
    setIsEmployeeLoaded(false);
    orgStructure
      .getEmployeesByCompanyIdAndLanguage(id, i18n.language)
      .then((res) => {
        if (res) {
          setCompanyEmployees(res);
          setSelectedCompanyEmployees(res);
          setIsEmployeeLoaded(true);
        }
      })
      .catch((err) => console.log(err));
  };

  const getRolesForCompany = (id) => {
    if (id === null) {
      setRoleList([]);
      return;
    }
    orgStructure
      .getCompanyRoles(id)
      .then((res) => {
        if (res) {
          const filteredData = res.filter(
            (item) => item.is_organization_role === 0,
          );
          setRoleList(filteredData);
        }
      })
      .catch((err) => console.log(err));
  };

  const getEmployeesOfRole = (BU, roleId) => {
    organisation.getEmployeeByRole(BU, roleId, i18n.language).then((result) => {
      setManagers(result);
    });
  };

  const handleRoleSelectForBU = (BU, roleId) => {
    CustomToast('success', t('Selected Role'));
    getEmployeesOfRole(BU, roleId);
  };

  const handleRepeportingAssignment = (assignment) => {
    orgStructure
      .assignReporting(assignment)
      .then((result) => {
        if (result.response === 'warning') {
          setAssert(true);
          setUpdateOnConfirm(assignment);
        } else {
          if (result?.data?.ExistingUser.length > 0) {
            const existingUsers = result?.data?.ExistingUser?.join(', ');
            CustomToast(
              'error',
              `${existingUsers} These employees already have is direct manager reportee`,
            );
          } else {
            CustomToast('success', t('Reporting Assignment Success!'));
          }
          setAddFaceReport(false);
          setCompanyEmployees([]);
          refreshFaceReportingStructure();
        }
      })
      .catch((err) => {
        CustomToast(
          'error',
          t(
            'Error! Please try by selecting company, employees and reporting manager again.',
          ),
        );
      });
  };

  const handleConfirm = () => {
    setAssert(false);
    orgStructure
      .overwriteReporting(updateOnConfirm)
      .then((result) => {
        CustomToast('success', t('Reporting Assignment Success!'));
        setAddFaceReport(false);
        setCompanyEmployees([]);
        refreshFaceReportingStructure();
      })
      .catch((err) => {
        CustomToast('error', t('Failed to Assign Reporting Structure'));
      });
  };

  return (
    <>
      <EditManager
        open={openEditFaceReportee}
        record={currentfaceReportingToEdit}
        key={openEditFaceReportee}
        onRefresh={refreshFaceReportingStructure}
        onClose={handleCloseFaceEditReporteeModal}
        // onHandlePending={onHandlePending}
        pageFrom={'faceReportStructure'}
      />
      <div className="w-full">
        {addFaceReport ? (
          <div className="w-full">
            <NewReportingStructure
              companies={companySubsidaries}
              employees={selectedCompanyEmployees}
              rolesForBU={roleListForRoleAssignment}
              onBUSelect={handleSelectCompany}
              onRoleBUSelect={getRolesForCompany}
              onRoleSelect={handleRoleSelectForBU}
              managers={managers}
              onHandleAssignee={handleRepeportingAssignment}
              onCancel={() => {
                setAddFaceReport(false);
                setCompanyEmployees([]);
              }}
              isEmployeeLoaded={isEmployeeLoaded}
              pageFrom={'faceReportStructure'}
            />
          </div>
        ) : (
          <>
            <div className="flex flex-row my-5">
              <div className="w-[20.188em]">
                <HrSearchComponents
                  value={debouncedTerm}
                  onChange={(e) => {
                    setQuery(e);
                  }}
                />
              </div>
              <div className="flex flex-row justify-end w-full">
                <div className="mx-1">
                  <ClockInButton
                    title={t('Add Face Report Structure')}
                    startIcon={<i className="las la-plus"></i>}
                    onClick={() => setAddFaceReport(true)}
                  />
                </div>
              </div>
            </div>

            <MUIDataTable
              title=""
              columns={faceReportStructureColumns}
              data={faceReportStructureData}
              options={{
                ...optionsFaceReportStructure,
                page,
                serverSide: true,
                count: totalCount,
                rowsPerPage,
                onChangePage: (page) => setPage(page),
                onChangeRowsPerPage: changeRowsPerPage,
                rowsPerPageOptions: pagination_list.table,
                onSearchChange: (searchText) => {
                  setDebounceTerm(searchText);
                },
              }}
            />
          </>
        )}
      </div>

      <ConfirmModal open={assert} onClose={() => setAssert(false)}>
        <h2 className="mb-4 text-lg font-bold">
          {t('Change the Report Allocation?')}
        </h2>

        <div className="flex flex-col items-center gap-4">
          <Warning />
          <p className="text-center text-base">
            {t(
              'Employee already have reporting line with same role. Overwrite?',
            )}
          </p>
        </div>

        <div className="mt-6 flex justify-end gap-2">
          <button
            onClick={() => setAssert(false)}
            className="h-[42px] w-[120px] rounded-lg border border-[#FFEDEF] bg-[#FFEDEF] text-sm text-[#FF5263] normal-case hover:bg-[#ffe1e5]"
          >
            {t('No')}
          </button>
          <button
            onClick={handleConfirm}
            className="h-[42px] w-[120px] rounded-lg border border-[#7C0E6F] bg-[#7C0E6F] text-sm text-white normal-case hover:bg-[#6a0c60]"
          >
            {t('Overwrite')}
          </button>
        </div>
      </ConfirmModal>
    </>
  );
};

export default FaceReportStructure;
